export default __webpack_public_path__ + "static/media/pricing.e5606470.svg";